var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-con h-full" }, [
    _c(
      "div",
      { staticClass: "list-container flex flex-col align-center" },
      _vm._l(_vm.pageData.diagRecords, function (item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "list-item w-full flex flex-row justify-between",
            on: {
              click: function ($event) {
                return _vm.handleClickDiagRecord(item)
              },
            },
          },
          [
            _c("div", { staticClass: "name-con flex flex-row align-center" }, [
              item.sexSign === "2"
                ? _c("img", {
                    staticClass: "profile",
                    attrs: {
                      alt: "头像",
                      src: require("@/assets/treatment/profileFemale.png"),
                    },
                  })
                : _c("img", {
                    staticClass: "profile",
                    attrs: {
                      alt: "头像",
                      src: require("@/assets/treatment/profileMale.png"),
                    },
                  }),
              _c("div", { staticClass: "name mr-5" }, [
                _vm._v(_vm._s(item.patientName)),
              ]),
            ]),
            _c("div", { staticClass: "info flex flex-row align-center" }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }